import { UserModel } from './userModel';
import { MyMedicineModel } from './myMedicineModel'
import { MyConditionModel } from './myConditionModel';
import { MyDiseaseModel } from './myDiseaseModel';
import { MyFamilyModel } from './myFamilyModel';
import { MyLabResultModel } from './myLabresultModel';
import { MyPrescriptionMidel } from './myPrescriptionModel';

export class UserDashboardModel {
    public user: UserModel;
    public myMedicine: MyMedicineModel;
    public myCondition: MyConditionModel;
    public myDisease: MyDiseaseModel;
    public myFamily: MyFamilyModel;
    public myLabResult: MyLabResultModel;
    public myPrescription: MyPrescriptionMidel;
}